import React, { useEffect } from 'react';
import { withFormik } from "formik";
import * as Yup from "yup";

import FormikInput from "../Forms/FormikFormGroup/FormikInput";
import BasicDropdown from "../Forms/BasicDropdown";
import {
  companyValidation,
  emailWithUmlautsValidation,
  nameValidation,
  phoneOrderValidation,
} from "../Forms/ValidationSchemaPattern";
import { EllipsisLoader } from "../Loaders";
import SvgIcon from "../Icons";
import { phoneCodes } from "./data";

import './index.sass';


const ContactsStepWrapper = ({ closeMobileForm,
                               errors,
                               handleBlur,
                               handleChange,
                               handleSubmit,
                               goBack,
                               loading,
                               resetForm,
                               resetTrigger,
                               setFieldValue,
                               setValidationTrigger,
                               submitButtonText,
                               submitStep,
                               touched,
                               validationTrigger,
                               values,
                             }) => {

  useEffect(() => {
    if (validationTrigger) {
      submitStep(values);
      goBack();
    }
  }, [validationTrigger]);


  useEffect(() => {
    validationTrigger && setValidationTrigger(false);
  }, [errors]);


  useEffect(() => {
    if (resetTrigger) {
      resetForm();
      resetTrigger();
    }
  }, [resetTrigger]);


  const handleCancel = () => {
    resetForm();
    closeMobileForm();
  };


  return (
    <form name="bookingFormSecondStep" className="booking-form-second-step" id="new_place_enquiry" onSubmit={handleSubmit}>

      <div className="booking-form__contact-info-headline">
        <SvgIcon name="account_box" className="booking-form__contact-info-icon" size={24} />
        Kontaktoplysninger
      </div>

      <FormikInput
        id="name"
        error={errors.name}
        handleBlur={handleBlur}
        handleChange={handleChange}
        placeholder="Dit navn"
        required={true}
        touched={touched.name}
        value={values.name}
      />

      <FormikInput
        id="company_name"
        error={errors.company_name}
        handleBlur={handleBlur}
        handleChange={handleChange}
        placeholder="Evt. Firmanavn"
        touched={touched.company_name}
        value={values.company_name}
      />

      <FormikInput
        id="email"
        error={errors.email}
        handleBlur={handleBlur}
        handleChange={handleChange}
        placeholder="E-mail"
        required={true}
        touched={touched.email}
        value={values.email}
      />

      <div className={`booking-form__phone-input-wrapper ${errors.phone && touched.phone ? 'error' : ''}`}>
        <BasicDropdown
          currentValue={phoneCodes.find(option => option.id === values.phone_code)}
          handleChange={(value) => setFieldValue('phone_code', value.id)}
          options={phoneCodes}
          wrapperClass="phone_code"
        />

        <div className="booking-form__phone-input-divider" />

        <FormikInput
          id="phone"
          handleBlur={handleBlur}
          handleChange={handleChange}
          placeholder="Telefonnummer"
          required={true}
          type="tel"
          value={values.phone}
        />

        <div className="booking-form__phone-input-border" />
      </div>

      { errors.phone && touched.phone && <div className="form-group__error-tooltip phone">{ errors.phone }</div> }


      <div className="booking-form__submit-wrapper">
        <div className={`booking-form__mobile-back-button ${loading ? 'inactive' : ''}`}
             onClick={() => goBack ? submitStep(null, 1) : handleCancel()}>
          { goBack ? 'Tilbage' : 'Annullér' }
        </div>

        <button type="submit" className={`booking-form__submit-button ${loading ? 'inactive' : ''}`}>
          { loading ? <EllipsisLoader /> : submitButtonText }
        </button>
      </div>

    </form>
  )
}


const ContactsStep = withFormik({

  mapPropsToValues: (bag) => ({
    company_name: bag.currentValues.company_name || '',
    email: bag.currentValues.email || '',
    name: bag.currentValues.name || '',
    phone: bag.currentValues.phone || bag.userCountryPhoneCode || '',
    phone_code: bag.currentValues.phone_code || '45',
  }),

  validationSchema: Yup.object().shape({
    company_name: companyValidation,
    email: emailWithUmlautsValidation,
    name: nameValidation,
    phone: phoneOrderValidation,
    phone_code: Yup.string(),
  }),

  handleSubmit: (values, bag) => {
    bag.props.submitStep(values);
  },

  displayName: 'BookingFormSecondStep',
})(ContactsStepWrapper);

export default ContactsStep;
